import React from 'react';
import PlanteNews from '../../assets/img/newsLetter/verticalArrow.svg';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';

function RegistrationSuccessModal({ isOpen, onClose, onResendEmail, isButtonDisabled, resendTimer }) {
    const { t } = useTranslation();
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="py-3 text-start">
                <h2 className="text-2xl font-bold font-heading uppercase">
                    {t('registrationM.title')}
                </h2>
            </div>
            <p className="my-4 text-start">
                {t('registrationM.text2')}
            </p>
            <div className="flex justify-center mb-4">
                <img
                    src={PlanteNews}
                    className="max-w-full max-h-full block py-6 rotate-270"
                    style={{ maxHeight: '300px', objectFit: 'cover' }}
                    alt="Immagine"
                />
            </div>
            <p className="text-center">
                {t('registrationM.text4')}
            </p>

            {/* Layout verticale per i bottoni e il counter */}
            <div className="flex flex-col items-center mt-8 space-y-2">
                {/* Bottone per reinviare l'e-mail */}
                <button
                    className={`px-4 py-3 text-white bg-burnt-coffee w-full uppercase font-heading  rounded-lg ${isButtonDisabled ? 'cursor-not-allowed opacity-50' : ''}`}
                    onClick={onResendEmail}
                    disabled={isButtonDisabled}
                >
                    {t('registrationM.resendEmail') || 'Invia nuovamente e-mail'}
                </button>

                {/* Mostra il counter solo se il bottone è disabilitato */}
                {isButtonDisabled && (
                    <div className="text-center">
                        Riprova tra {resendTimer}s
                    </div>
                )}

                {/* Bottone per andare alla homepage */}
                <button
                    className="px-4 py-3 w-full bg-wild-ocean text-white uppercase font-heading rounded-lg"
                    onClick={onClose}
                >
                    {t('registrationM.buttons')}
                </button>
            </div>
        </Modal>
    );
}

export default RegistrationSuccessModal;
